var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-dashboard',[_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('sortable-firmwide-emission-by-product-family')],1),_c('b-col',{attrs:{"lg":"6"}},[_c('selectable-year-firmwide-emission-by-product-family')],1)],1),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('lca-progress')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }